/**
 * Typography Design Tokens
 * Mirrors fonts.module.css structure
 */

export const fontSizes = {
  xxsmall: 10, // 0.625rem
  xsmall: 12, // 0.75rem
  small: 14, // 0.875rem
  normal: 16, // 1rem
  large: 18, // 1.125rem
  xlarge: 20, // 1.25rem
  xxlarge: 22, // 1.375rem
  xxxlarge: 24, // 1.5rem
  headerNormal: 24, // 1.5rem
  headerXlarge: 42, // 2.625rem
};

export const fontWeights = {
  thin: 100,
  extraLight: 200,
  light: 300,
  normal: 400,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  heavy: 900,
};

export const fontFamilies = {
  system: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
  sfProText: '"SF Pro Text", sans-serif',
};

export const lineHeights = {
  base: 1.5714, // Ant Design v5 default
  small: 1.66, // For smaller text
  large: 1.4, // For larger text
  heading: 1.2, // For headings
  xLarge: 20,
  xxLarge: 22,
  xxxLarge: 24,
};
